import Vue from 'vue';
import Vuex from 'vuex';
import account from './module/account.js';
import activity from './module/activity.js';
import gameCenter from './module/gameCenter';
import gameCircle from './module/gameCircle';
import gameCircleCenter from './module/gameCircleCenter';
import giftCenter from './module/giftCenter';
import personalCenter from './module/personalCenter';
import tgStore from './module/tgStore';
import app from './module/app';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    account,
    activity,
    gameCenter,
    gameCircle,
    gameCircleCenter,
    giftCenter,
    personalCenter,
    app,
    tgStore
  },
});
